"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _assignRef = _interopRequireDefault(require("../../../utils/assignRef"));

var _context = require("../context");

var _styles = require("./styles");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Tab = (0, _react.forwardRef)(function (_ref, ref) {
  var id = _ref.id,
      children = _ref.children,
      icon = _ref.icon,
      title = _ref.title,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, ["id", "children", "icon", "title", "onClick", "disabled"]);

  var _useTabs = (0, _context.useTabs)(),
      register = _useTabs.register,
      activate = _useTabs.activate,
      activeId = _useTabs.activeId,
      onKeyDown = _useTabs.onKeyDown,
      size = _useTabs.size;

  var Icon = icon;
  var isActive = id === activeId;
  var internalRef = (0, _react.useRef)(null);
  var handleClick = (0, _react.useCallback)(function (e) {
    !disabled && activate(id);
    onClick && onClick(e);
  }, [id, activate, disabled, onClick]);

  var assignRefs = function assignRefs(node) {
    (0, _assignRef.default)(ref, node);
    (0, _assignRef.default)(internalRef, node);
  };

  (0, _react.useEffect)(function () {
    var unregister = register(id, {
      isDisabled: !!disabled,
      content: children,
      ref: internalRef
    });
    return unregister;
  }, [id, disabled, children, internalRef, register]);
  return _react.default.createElement(_styles.TabContainer, _extends({}, rest, {
    "aria-controls": "tab-panel-".concat(id),
    "aria-selected": isActive,
    disabled: !!disabled,
    id: "tab-".concat(id),
    onClick: handleClick,
    onKeyDown: onKeyDown,
    ref: assignRefs,
    role: "tab",
    size: size || 'normal',
    tabIndex: isActive ? 0 : -1,
    type: "button"
  }), Icon && _react.default.createElement(Icon, {
    size: "medium"
  }), _react.default.createElement("span", null, title));
}); // @ts-ignore

Tab.propTypes = {
  id: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired,
  icon: _propTypes.default.elementType,
  disabled: _propTypes.default.bool
};
Tab.displayName = 'Tab';
Tab.defaultProps = {
  icon: undefined,
  disabled: false
};
var _default = Tab;
exports.default = _default;